import { useEffect, useState } from 'react'

import { IconGridSizeDefault, IconGridSizeMinimised } from '@avantstay/backoffice-vectors'

import {
  getSidePanelContentMode,
  isSidePanelContentModeToggleEnabled,
  SidePanelContentMode,
  subscribeSidePanelContentMode,
  toggleSidePanelContentMode,
} from '../../utils/sidePanelContentMode'
import { Tooltip } from '../Tooltip'
import * as S from './AttachmentBar.styles'

// Header button switching the per-user side panel preference between pushing
// the page content aside and overlaying it. Renders nothing unless the app
// opted in via enableSidePanelContentModeToggle(). Used by the native
// AttachmentBar header; drop it into custom panel headers next to their close button.
export const SidePanelContentModeToggle = () => {
  const [contentMode, setContentMode] = useState<SidePanelContentMode>(getSidePanelContentMode)

  useEffect(() => subscribeSidePanelContentMode(setContentMode), [])

  if (!isSidePanelContentModeToggleEnabled()) {
    return null
  }

  return (
    <Tooltip
      content={
        contentMode === 'push'
          ? 'Overlay the page content instead of pushing it aside'
          : 'Push the page content aside instead of overlaying it'
      }
      placement="bottom"
    >
      <S.ContentModeToggleButton
        onClick={toggleSidePanelContentMode}
        type="button"
        data-cy="attachment-bar-content-mode-toggle"
      >
        {contentMode === 'push' ? <IconGridSizeDefault /> : <IconGridSizeMinimised />}
      </S.ContentModeToggleButton>
    </Tooltip>
  )
}
